module.exports = __webpack_public_path__ + "static/img/letters_patent.6a91c48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/letters_patent.png
// module id = 2Ahe
// module chunks = 1